import React from "react";
import { Row, Col } from "antd";
import { useTranslation } from "react-i18next";

import { PageContent, Container, Content } from "common/layout";
import { H1 } from "common/text";

import photo500 from "assets/ltl-500.jpg";

const Page500 = () => {
  const { t } = useTranslation("error");

  const renderImage = () => <img src={photo500} alt="ltl-500" />;

  return (
    <PageContent style={{ backgroundColor: "white" }}>
      <Container>
        <Content>
          <Row style={{ marginTop: 50 }} gutter={24}>
            <Col md={{ span: 10, offset: 2 }} sm={24}>
              <H1>
                {t("Sorry, there seems to be a bug")}
                <br />
                {t("crawling around somewhere in our system")}
              </H1>
              <p style={{ fontSize: 16, textAlign: "justify" }}>
                {t(
                  "Try to refresh the page or close your browser and log in again to make it disappear."
                )}
              </p>
              <p style={{ fontSize: 16, textAlign: "justify" }}>
                {t(
                  "Our team is looking into the report and will try to rectify it as soon as possible. In the meantime, please feel free to contact our support at"
                )}{" "}
                <a href="mailto:support@flexiclasses.com">
                  support@flexiclasses.com
                </a>{" "}
                {t("if you have any further questions or comments.")}
              </p>
            </Col>
            <Col md={{ span: 8, offset: 0 }} sm={24}>
              {renderImage()}
            </Col>
          </Row>
        </Content>
      </Container>
    </PageContent>
  );
};

export default Page500;
